// Keep eligibility separate from the return lock so unlocking does not enable
// a button that the calc server disabled. Weak keys expire when forms are replaced.
const disabledByEligibility = new WeakMap();

export const isButtonDisabledByEligibility = button => disabledByEligibility.get(button) === true;

export const applyDisabledButtons = (commands, root = document) => {
  // Older responses and responses without button state leave the current state alone.
  if (!Array.isArray(commands)) return;

  const disabledCommands = new Set(commands);
  root.querySelectorAll('.form-button-element[data-cmd]').forEach(button => {
    const disabled = disabledCommands.has(button.getAttribute('data-cmd'));
    disabledByEligibility.set(button, disabled);
    button.disabled = disabled || button.classList.contains('lockedField');
  });
};
